export const PROGRAMS = {
  pageHeading: 'programs-page-heading',
  programSelenium: 'program-card-selenium',
  programPlaywright: 'program-card-playwright',
  programAppium: 'program-card-appium',
  curriculumAccordion: 'program-curriculum-accordion',
  registerButton: 'program-register-button',
  detailsButton: 'program-details-button',
};

export const CONTACT = {
  nameInput: 'contact-name-input',
  emailInput: 'contact-email-input',
  phoneInput: 'contact-phone-input',
  messageInput: 'contact-message-input',
  submitButton: 'contact-submit-button',
};

export const FEEDBACK = {
  urbanproLink: 'feedback-urbanpro-link',
  trustpilotLink: 'feedback-trustpilot-link',
  googleLink: 'feedback-google-link',
  claimCertButton: 'feedback-claim-certificate-button',
};

export const GALLERY = {
  filterAll: 'gallery-filter-all',
  filterWorkshops: 'gallery-filter-workshops',
  filterEvents: 'gallery-filter-events',
  filterAwards: 'gallery-filter-awards',
  imageItem: 'gallery-image-item',
};
